// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"235b5ef0","453":"fe0e1096","703":"1ce97a23","845":"5deb0595"}[chunkId] + ".chunk.js";
};